"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Save = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const Save = ({ fill = "#E6E6E6", size = 16, }) => (react_1.default.createElement(Base_1.Base, { size: size, smooth: true },
    react_1.default.createElement("g", { stroke: fill, strokeWidth: "1", strokeLinejoin: "round" },
        react_1.default.createElement("path", { d: "M15.5,15.5h-15v-15h14l1,1z", fill: "none" }),
        react_1.default.createElement("path", { d: "M11.5,6.5h-7V1h7zV1H8v5z", fill: fill }))));
exports.Save = Save;
//# sourceMappingURL=Save.js.map